import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import * as Icons from 'components/icons';
import { Button } from './style';

function IconButton({
  children,
  className,
  color = 'default',
  component: Component,
  disabled = false,
  icon,
  size = 'medium',
  type = 'button',
  variant = 'text',
  onClick,
  ...rest
}) {
  const Icon = useMemo(() => (icon && Icons[icon]) || Icons.Question, [icon]);

  return (
    <Button
      $color={color}
      $variant={variant}
      $size={size}
      as={Component}
      className={className}
      disabled={disabled}
      aria-disabled={disabled}
      data-disabled={disabled}
      onClick={onClick}
      type={type}
      {...rest}
    >
      {children || <Icon />}
    </Button>
  );
}

IconButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  className: PropTypes.string,
  color: PropTypes.oneOf(['danger', 'default', 'primary', 'secondary']),
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  disabled: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.func, PropTypes.node, PropTypes.object]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  type: PropTypes.oneOf(['button', 'submit']),
  variant: PropTypes.oneOf(['lightText', 'text']),
  onClick: PropTypes.func
};

export default React.memo(IconButton);
